import { Contract } from '@ecm/portfolio';

import { Button } from '../../../api/dashboard/forbidden/button';
import { ClientTypeEnum } from '../../../api/dashboard/forbidden/clientType.enum';
import { Forbidden } from '../../../api/dashboard/forbidden/forbidden';
import { ButtonViewModel } from '../../../model/home/button.view-model';
import { ForbiddenViewModel } from '../../../model/home/forbidden/forbidden.view-model';
import { TmsCodes } from '../../../model/tracking/tmsCodes.enum';
import { TrackedName } from '../../../model/tracking/trackedName.enum';
import { TrackedPage } from '../../../model/tracking/trackedPage.enum';

export const ForbiddenDataMapper = {
    extractForbiddenContract: (forbidden: Forbidden): ForbiddenViewModel => {
        const model = {
            cid: forbidden.cid,
            clientType: forbidden.clientType,
            title: forbidden.title,
            contractInfos: forbidden.contractInfos,
            texts: forbidden.text,
            trackingLabel: ForbiddenDataMapper.getTrackingLabel(forbidden.clientType),
            changeUniverse: forbidden.changeUniverse,
            banner: forbidden.banner,
            isProtectedHouseV2: forbidden.isProtectedHouseV2,
            isInQuarantine: forbidden.isInQuarantine ? forbidden.isInQuarantine : false,
        } as ForbiddenViewModel;
        if (forbidden.subtitle) {
            model.subtitle = forbidden.subtitle;
        }
        if (forbidden.detail) {
            model.detail = forbidden.detail;
        }
        if (forbidden.buttons?.[0]) {
            model.primaryButton = ForbiddenDataMapper.getForbiddenButton(forbidden.buttons[0], forbidden.clientType);
        }
        if (forbidden.buttons?.[1]) {
            model.secondaryButton = ForbiddenDataMapper.getForbiddenButton(forbidden.buttons[1], forbidden.clientType);
        }
        return model;
    },

    getTrackingLabel: (clientType: ClientTypeEnum): TmsCodes => {
        let tmsCodes: TmsCodes;
        switch (clientType) {
            case ClientTypeEnum.NSRU: {
                tmsCodes = TmsCodes.care_hp_nsru;
                break;
            }
            case ClientTypeEnum.MULTIBAL: {
                tmsCodes = TmsCodes.care_hp_multibal;
                break;
            }
            case ClientTypeEnum.PARNASSE: {
                tmsCodes = TmsCodes.care_hp_parnasse;
                break;
            }
            case ClientTypeEnum.SUGGESTED: {
                tmsCodes = TmsCodes.care_selecteurcontrat_rapproche;
                break;
            }
            case ClientTypeEnum.OBS: {
                tmsCodes = TmsCodes.care_hp_obs;
                break;
            }
            case ClientTypeEnum.PRO: {
                tmsCodes = TmsCodes.care_hp_pro;
                break;
            }
            case ClientTypeEnum.PROTECTEDHOUSE: {
                tmsCodes = TmsCodes.care_hp_maison;
                break;
            }
            default: {
                break;
            }
        }
        return tmsCodes;
    },

    getForbiddenButton: (forbiddenButton: Button, clientType: ClientTypeEnum): ButtonViewModel => {
        const button = {
            label: forbiddenButton.text,
            trackingName: forbiddenButton.text,
            link: forbiddenButton.link,
        } as ButtonViewModel;

        switch (clientType) {
            case ClientTypeEnum.NSRU: {
                button.trackedPage = TrackedPage.accueil_dashboard;
                button.trackingArea = TmsCodes.care_hp_nsru;
                break;
            }
            case ClientTypeEnum.MULTIBAL: {
                button.trackedPage = TrackedPage.accueil_dashboard;
                button.trackingArea = TmsCodes.care_hp_multibal;
                break;
            }
            case ClientTypeEnum.PARNASSE: {
                button.trackedPage = TrackedPage.accueil_dashboard;
                button.trackingArea = TmsCodes.care_hp_parnasse;
                break;
            }
            case ClientTypeEnum.SUGGESTED: {
                button.trackedPage = TrackedPage.accueil_dashboard;
                button.trackingArea = TmsCodes.care_selecteurcontrat_rapproche;
                break;
            }
            case ClientTypeEnum.OBS: {
                button.trackedPage = TrackedPage.accueil_dashboard;
                button.trackingArea = TmsCodes.care_hp_obs;
                break;
            }
            case ClientTypeEnum.PRO: {
                button.trackedPage = TrackedPage.accueil_dashboard;
                button.trackingArea = TmsCodes.care_hp_pro;
                break;
            }
            case ClientTypeEnum.PROTECTEDHOUSE: {
                button.trackedPage = TrackedPage.accueil_dashboard;
                button.trackingArea = TmsCodes.care_hp_maison;
                button.trackingName = TrackedName.PROTECTEDHOUSE_V1;
                break;
            }
            case ClientTypeEnum.TERMINATED: {
                button.trackedPage = TrackedPage.accueil_dashboard;
                button.trackingArea = TmsCodes.care_hp_contrat_inactif;
                break;
            }
            default: {
                break;
            }
        }
        return button;
    },

    getChangeUniverseViewModel: (changeUniverseTranslation: any, contract?: Contract): ButtonViewModel => {
        let button = null;
        if (contract) {
            const brandedChangedUniverse =
                contract.brand === 'Orange' ? changeUniverseTranslation['orange'] : changeUniverseTranslation['sosh'];
            button = new ButtonViewModel(brandedChangedUniverse.label);
            button.link = brandedChangedUniverse.link;
            button.trackedPage = TrackedPage.accueil_dashboard;
            button.trackingArea = TmsCodes.care_hp_contrat_inactif;
            button.trackingName = brandedChangedUniverse.label;
            button.switchBrand = true;
        }

        return button;
    },
};
